var React = require('react');

function Houzz (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m14.681 24h8.069v-13.633l-16.151-4.621v-5.746h-5.349v24h8.069v-7.556h5.362z"}));
}

Houzz.defaultProps = {"id":"Bold","enableBackground":"new 0 0 24 24","height":"512","viewBox":"0 0 24 24","width":"512"};

module.exports = Houzz;

Houzz.default = Houzz;
